let counter = 0;

const uniqueId = (prefix = 'input_') => {
    counter++

    return `${prefix}${counter}`
};

export default uniqueId;
